// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"8e700604","386":"718a55d8","608":"382c92f0","668":"92af707d","728":"4ffec106","768":"6c26c7c4"}[chunkId] + ".chunk.js";
};